export const NOTIFICATIONS_COUNT_ACTION = 'NOTIFICATIONS_COUNT_ACTION';
export const NOTIFICATIONS_COUNT_SUCCESS_ACTION =
  'NOTIFICATIONS_COUNT_SUCCESS_ACTION';
export const NOTIFICATIONS_COUNT_FAILURE_ACTION =
  'NOTIFICATIONS_COUNT_FAILURE_ACTION';
